import { ThemeProvider } from "@commerce-core/react-components";
import { Top5LinkEnhancer } from "@commerce-core/react-components";
import Layout from "@/Layout";
import "./theme.css";

declare global {
  interface Window {
    post_template?: {
      header?: {
        link_color?: string;
      };
    };
    post_content?: string;
  }
}

function App() {
  const root = window?.post_template || {};

  const themeVariables = {
    "navigation-link-color": root?.header?.link_color || "#484848",
  };

  return (
    <Top5LinkEnhancer>
      <ThemeProvider variables={themeVariables}>
        <Layout root={root} />
      </ThemeProvider>
    </Top5LinkEnhancer>
  );
}

export default App;
